import React, { forwardRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Print = forwardRef(({ data }, ref) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  useEffect(() => {
    // Inject print styles into the document head
    const printStyles = `
      @media print {
        @page {
          size: 80mm auto;
          margin: 0;
        }
        html, body {
          margin: 0;
          padding: 0;
          height: 100%;
          overflow: hidden;
        }
        body * {
          visibility: hidden;
        }
        #printable, #printable * {
          visibility: visible;
        }
        #printable {
          position: absolute;
          left: 0;
          top: 0;
          width: 80mm;
          margin: 0;
          padding: 0;
        }
      }
    `;
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <div
      ref={ref}
      id="printable"
      style={{
        width: "80mm",
        fontFamily: "Arial, sans-serif",
        padding: "15px",
        boxSizing: "border-box",
        direction: direction,
      }}
    >
      {/* Header Section */}
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <h2 style={{ margin: "0", fontSize: "20px", fontWeight: "bold" }}>
          {t("print.turkishClinic")}
        </h2>
        <p style={{ margin: "5px 0", fontSize: "12px", fontWeight: "500" }}>
          {t("print.phone")}: +93 785 29 1616
        </p>
        <p style={{ fontSize: "11px", margin: "5px 0", color: "#555" }}>
          {t("print.address")}
        </p>

        {/* return policy */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              margin: "8px 0",
              fontStyle: "italic",
            }}
          >
            {t("print.returnPolicyNote")}
          </p>
        </div>

        <hr style={{ border: "1px dashed #333", margin: "15px 0" }} />
      </div>

      {/* Patient & Doctor Details */}
      <div style={{ fontSize: "14px", lineHeight: "1.6", color: "#333" }}>
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong>{t("pharmacy.patient")}:</strong>
          <span>{data.patient_display}</span>
        </div>
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong>{t("pharmacy.doctor")}:</strong>
          <span>{data.doctor_display}</span>
        </div>
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <strong>{t("pharmacy.total_price")}:</strong>
          <span>{Number(data.total_price) + Number(data.discount)}؋</span>
        </div>

        {data?.discount > 0 && (
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <strong>{t("pharmacy.discount","Discount")}:</strong>
            <span>{data.discount}؋</span>
          </div>
        )}

        {data?.discount > 0 && (
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <strong>{t("pharmacy.afterDiscount","After Discount")}:</strong>
            <span>{data.total_price}؋</span>
          </div>
        )}
      </div>

      {/* Footer Section */}
      <hr style={{ border: "1px dashed #333", margin: "15px 0" }} />
      <div style={{ textAlign: "center", color: "#555" }}>
        <p style={{ fontSize: "12px", margin: "8px 0" }}>{t("print.thanks")}</p>
        <p style={{ fontSize: "12px", margin: "8px 0" }}>
          {t("print.getWellSoon")}
        </p>
        <p style={{ fontSize: "11px", margin: "8px 0" }}>{t("print.cosmos")}</p>
      </div>
    </div>
  );
});

export default Print;
